import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { breadcrumbPrefixCls } from "@/base/components/breadcrumb/Breadcrumb.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Breadcrumb">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${breadcrumbPrefixCls}`]: {},
  },
});

export const useBreadcrumbStyle = genComponentStyleHook(
  ["Breadcrumb", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
